import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import EditableText from '../../Form/EditableText';
import Utils from '../../../utils/Utils';
import BlockProps from '../../../models/BlockProps';
import BlockTextData from './BlockTextData';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import useGetBackground from '../../../hooks/UseGetBackground';
import BackGroundImageModal from '../../Modals/ImageModal/BackGroundImageModal';
import useParallaxScript from '../../../hooks/useParallaxScript';
import config from '../../../config';

function BlockText({
  data, isEditing, isTemplate, editHandler, showImageModal, onCloseImageModal,
}: BlockProps) {
  const [props, setProps] = useState<BlockTextData>(data.data as BlockTextData);

  useEffect(() => {
    setProps(data.data as BlockTextData);
  }, [data.data]);

  const handleUpdate = (text?: string) => {
    props.text.value = text;
    editHandler(data.id, { ...props });
  };

  const elementUuid = uuid();
  useParallaxScript(props.url?.settings?.parallaxBool, elementUuid, config.backgroundImage.parallaxEffect);

  return (
    <Grid
      id={elementUuid}
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: '250px',
        padding: 1.5,
        overflow: 'hidden',
        ...useGetBackground(
          props.url?.solidColor,
          props.url?.value,
          props.url?.settings?.scale,
          props.url?.settings?.scaleBool,
        ),
        backgroundPosition: 'center 0px',
      }}
    >
      {(isEditing && !isTemplate) && (
        <BackGroundImageModal
          backgroundImage={props.url}
          isShowModal={showImageModal}
          onCloseModal={onCloseImageModal}
          handleOnConfirm={(url: BlockComponentImage) => {
            const tempBg = { ...props, url: { ...url } };
            setProps(tempBg);
            editHandler(data.id, tempBg);
          }}
        />
      )}

      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        className="block-content-wrapper"
      >
        {props.text && (
          <Grid
            item
            sx={[Utils.hoverBorder(isEditing), {
              maxWidth: '100%',
              maxHeight: '100%',
              height: '100%',
              width: '100%',
            }]}
          >
            <EditableText
              text={props.text.value}
              textColor={props.text.settings?.textColor}
              isEditable={isEditing && !isTemplate}
              updateHandler={handleUpdate}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

export default BlockText;
